import { forwardRef } from 'react';

import { Box, type BoxProps } from '@betterment/samba-react';

export type InputGroupProps = BoxProps & {
  fullWidth?: boolean;
};

export const InputGroup = forwardRef<HTMLDivElement, InputGroupProps>(
  ({ fullWidth = false, css: cssProp, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        css={{
          maxWidth: fullWidth ? '100%' : '400px',
          marginBottom: {
            base: 'space.300',
            sm: 'space.300',
            md: 'space.400',
          },
          ...cssProp,
        }}
        {...props}
      />
    );
  }
);

InputGroup.displayName = 'InputGroup';
